var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyOffersGoldUnlimited = function SvgMyOffersGoldUnlimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.474 17.816H7.526v13.179h17.948zM7.526 15.81c-1.119 0-2.026.898-2.026 2.005v13.18C5.5 32.102 6.407 33 7.526 33h17.948c1.119 0 2.026-.898 2.026-2.006V17.816a2.016 2.016 0 0 0-2.026-2.006z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.922 31.854V16.956h2.026v14.898z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.747 11.36a1.66 1.66 0 0 0-.291 2.345c.213.27.491.456.795.556l.03.01 2.58 1.031-.418-2.949-.003-.013a1.65 1.65 0 0 0-.324-.692 1.7 1.7 0 0 0-2.37-.288m-1.888 3.58a3.65 3.65 0 0 1 .64-5.16 3.74 3.74 0 0 1 5.214.633c.344.436.574.928.693 1.437q.021.074.033.152l.551 3.881c.163 1.147-.99 2.038-2.074 1.604l-3.337-1.334a3.7 3.7 0 0 1-1.72-1.214",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.267 11.392c.724.581.836 1.633.249 2.35-.218.266-.5.447-.805.542l-.03.01-2.598.987.47-2.942.004-.013c.054-.243.165-.478.336-.687a1.7 1.7 0 0 1 2.374-.247m1.824 3.612a3.65 3.65 0 0 0-.55-5.17 3.74 3.74 0 0 0-5.223.543c-.352.43-.59.918-.718 1.425a1 1 0 0 0-.036.151l-.62 3.872c-.183 1.143.954 2.054 2.046 1.64l3.36-1.277a3.7 3.7 0 0 0 1.74-1.184",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.998,
    cy: 4,
    r: 4,
    fill: "#ED000C"
  })));
};
export default SvgMyOffersGoldUnlimited;